import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { downloadApiAttachment } from 'actions/Attachments/downloadAttachment';
import { getReports } from 'actions/Reports/getReports';

import { GroupButtons } from 'shared/components/Buttons';
import { GroupButton } from 'shared/components/Buttons/GroupButton/components/GroupButton';
import { FullPageList } from 'shared/components/FullPageList/FullPageList';
import { reportsAccess } from 'shared/helpers/accesses/reportsAccess/reportsAccess';
import { REPORTS } from 'shared/helpers/constants/reports/reportsConstants';
import { itemsTemplate } from 'shared/helpers/constants/reports/reportsTableConfig';
import { toSnakeCase } from 'shared/helpers/parsers/text';

import { GenerateReportsModal } from '../GenerateReports/GenerateReportsModal';
import { StyledSection } from './StyledSection';

const renderActionButton = ({ user, access }, handleOpenModal) => (
  <GroupButtons>
    <GroupButton
      data-testid="generateReportActionButton"
      access={reportsAccess(user, access)}
      onClick={handleOpenModal}
      label={REPORTS.GENERATE}
      icon="add"
    />
  </GroupButtons>
);

const GlobalList = () => {
  const dispatch = useDispatch();
  const auth = useSelector(({ auth }) => auth);
  const { reports, isPending } = useSelector(({ reports }) => reports);
  const [displayGenerateReportsModal, setDisplayGenerateReportsModal] = useState(false);
  const [companyId, setCompanyId] = useState('');
  const downloadReportIsPending = useSelector(
    ({ downloadAttachmentStorage }) => downloadAttachmentStorage?.isPending,
  );

  const actions = [
    {
      icon: 'download',
      action: 'Download',
      onClick:
        ({ _id }) =>
        () =>
          dispatch(downloadApiAttachment(`files/single/${_id}`)),
    },
  ];

  useEffect(() => {
    dispatch(getReports());
  }, [getReports]);

  const toggleOpenCloseModal = id => {
    setCompanyId(id);
    setDisplayGenerateReportsModal(!displayGenerateReportsModal);
  };

  return (
    <>
      {reports &&
        reports.length !== 0 &&
        reports.map(company => (
          <StyledSection>
            <FullPageList
              title={REPORTS.ANALYSIS_REPORTS}
              subheader={company.companyName}
              itemsTemplate={itemsTemplate}
              actionButtons={() =>
                renderActionButton(auth, () => toggleOpenCloseModal(company._id))
              }
              actionsTemplate={actions}
              items={company.reports}
              dataTestId={toSnakeCase(`${REPORTS.REPORT} ${company.companyName}`)}
              isPending={isPending || downloadReportIsPending}
              disableInitialFetch
            />
          </StyledSection>
        ))}
      <GenerateReportsModal
        open={displayGenerateReportsModal}
        modalClose={toggleOpenCloseModal}
        companyId={companyId}
      />
    </>
  );
};

export { GlobalList };
